import { render, staticRenderFns } from "./SithMesStoolHandleProblematicPrList.vue?vue&type=template&id=5c95d799&"
import script from "./SithMesStoolHandleProblematicPrList.vue?vue&type=script&lang=js&"
export * from "./SithMesStoolHandleProblematicPrList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports